<template>
  <div class="container-fluid">
    <v-card
      color="red"
      flat
      tile
    >
      <v-toolbar dense
                 src="https://c.pxhere.com/photos/97/7d/breakfast_coffee_delicious_dish_drinks_egg_food_meal-1534997.jpg!d"
      >
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          width="1000"
          persistent
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="white"
              outlined
              dark
              v-bind="attrs"
              v-on="on"
              @click="editedItem = defaultItem"
            >
              Přidat menu
            </v-btn>
          </template>
           <MenuForm
             @formCanceled="dialog = false"
             :item="editedItem"
             v-if="dialog"
             @data-saved="getMenus"
           ></MenuForm>
        </v-dialog>
      </v-toolbar>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="menus"
      sort-by="internalName"
      class="elevation-1"
      :search="search"
      :items-per-page="-1"
      locale="cs"
      single-expand
      show-expand
      item-key="id"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Databáze menu</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledávání"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.specialOffer="{ item }">
        {{item.specialOffer ? 'Ano' : 'Ne' }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="duplicateItem(item)"
        >
          mdi-content-copy
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="archive(item)"
        >
          mdi-archive-arrow-down
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
          <b style="margin-right: 5px; margin-left: 5px">Položky:</b>
          <td :colspan="headers.length">
            <div v-for="(menuItem, index) in item.foods.concat(item.drinks)" :key="index">
              {{menuItem.name}}
            </div>
          </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import MenuForm from '../../components/forms/admin/MenuForm'
export default {
  Name: 'MenuDatabase',
  components: { MenuForm },
  data: () => ({
    loading: true,
    search: '',
    dialog: false,
    editedItem: {},
    duplicatedItem: {},
    defaultItem: {
      id: null,
      name: '',
      internalName: '',
      active: true,
      price: '',
      photo: null,
      weight: null,
      calories: null,
      foodTypes: [],
      timeTypes: [],
      foods: [],
      drinks: [],
      specialOffer: false
    },
    headers: [
      {
        text: 'Interní název',
        align: 'start',
        sortable: true,
        value: 'internalName'
      },
      { text: 'Název menu', value: 'name' },
      { text: 'Typ menu', value: 'typesStr' },
      { text: 'Denní doba', value: 'timesStr' },
      { text: 'Obsah menu', value: 'content' },
      { text: 'Alergeny', value: 'alergensStr' },
      { text: 'Cena', value: 'price' },
      { text: 'Objem', value: 'volume' },
      { text: 'Hmotnost', value: 'weight' },
      { text: 'Kalorie', value: 'calories' },
      { text: 'Speciální nabídka', value: 'specialOffer' },
      { text: 'Akce', value: 'actions', sortable: false }
    ],
    menus: []
  }),
  created () {
    this.initialize()
    this.getMenus()
  },

  methods: {
    initialize () {
    },
    getMenus () {
      this.menus = []
      this.dialog = false
      this.loading = true
      this.$http.get('/admin/menus')
        .then(response => {
          this.menus = this.keysToCamelCase(response.data)
            .filter(item => item.visible)
            .map(menu => {
              menu.timesStr = menu.timeTypes
                .map(time => time.name)
                .join(', ')
              menu.typesStr = menu.foodTypes
                .map(type => type.name)
                .join(', ')
              menu.alergensStr = menu.alergens
                .map(alergen => alergen.name)
                .join(', ')
              menu.content = menu.foods.concat(menu.drinks)
                .map(item => item.name)
                .join(', ')
              menu.volume = menu.drinks
                .map(drink => drink.volume)
                .join(', ')
              return menu
            })
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    duplicateItem (item) {
      this.editedItem = Object.assign({}, item)
      this.editedItem.id = null
      this.dialog = true
    },
    archive (item) {
      this.$http.post(`admin/menus/${item.id}/archive`)
        .then(() => {
          this.getMenus()
        })
    }
  }
}
</script>

<style scoped>

</style>
